import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SOURCE_KG_NOTE } from '../utils/lineWeight';

// 14ykpqtv3qw — shown when the extraction read the source's quantities as kilograms. SO lines are pieces, and
// on an SO source a kg label is most likely a misread (prod SO 227's "9,324 kgs" lines were pieces) — so the
// lines are kept as pieces and the coordinator is told to check the original. Non-blocking (owner, 2026-10-14).
// Same warning strip as PerGradeBalanceChips' over-allocation note.
export function SourceKgNotice({ className }: { className?: string }) {
  return (
    <div
      role="note"
      className={cn(
        'flex items-start gap-2 rounded-md border border-warning/30 bg-warning/10 px-3 py-2 text-xs text-warning',
        className,
      )}
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>{SOURCE_KG_NOTE}</span>
    </div>
  );
}
